import { MediaSelect } from "@/(admin)/modules/media/pages/SelectMediaUIBuilder"
import { getConfigs } from "@/configs"
import { ComponentConfig } from "@measured/puck"
import SelectBanner from "../../../components/SelectBanner"
import { RenderConfig, TamdaMediaHeaderProps } from "./RenderConfig"
export const TamdaMediaHeader: ComponentConfig<TamdaMediaHeaderProps> = {
  label: "Tamda Media | Header",
  fields: {
    bannerId: {
      label: "Banner",
      type: "custom",
      render: ({ value, onChange }) => {
        const configs = getConfigs("tamdamedia.eu")
        const allowedBannerIds: number[] | undefined =
          configs.HEADER_BANNER_ID !== undefined ? [configs.HEADER_BANNER_ID] : undefined

        return (
          <SelectBanner
            placeholder="Chọn banner"
            value={value}
            onChange={val => onChange(val ?? "")}
            allowedBannerIds={allowedBannerIds}
          />
        )
      },
    },
    bannerAltText: {
      label: "Banner Alt Text",
      type: "text",
    },
    bannerLink: {
      label: "Banner Link (Optional)",
      type: "text",
    },
    bannerTarget: {
      label: "Banner Target",
      type: "select",
      options: [
        { value: "_blank", label: "New Tab" },
        { value: "_self", label: "Same Tab" },
      ],
    },
    bannerClickUrl: {
      label: "Banner Click Tracking URL",
      type: "text",
    },
    bannerImpressionHtml: {
      label: "Banner Impression HTML (JSON)",
      type: "textarea",
    },
    bannerVendorScriptSrc: {
      label: "Banner Vendor Script URL",
      type: "text",
    },
    bannerVendorNoscriptHtml: {
      label: "Banner Vendor Noscript HTML",
      type: "textarea",
    },
    showBanner: {
      label: "Show Banner",
      type: "radio",
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
    contactPhone: {
      label: "Contact Phone",
      type: "text",
    },
    currencyRateText: {
      label: "Currency Rate Text (Leave empty to use API)",
      type: "text",
    },
    showHeaderDetail: {
      label: "Show Header Detail Section",
      type: "radio",
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
    menuName: {
      label: "Menu Name",
      type: "text",
    },
    showHeaderList: {
      label: "Show Navigation Menu",
      type: "radio",
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
    facebookLink: {
      label: "Facebook Link",
      type: "text",
    },
    youtubeLink: {
      label: "Youtube Link",
      type: "text",
    },
    facebookIcon: {
      label: "Facebook Icon",
      type: "custom",
      render: props => <MediaSelect {...props} mediaType="image" />,
    },
    youtubeIcon: {
      label: "Youtube Icon",
      type: "custom",
      render: props => <MediaSelect {...props} mediaType="image" />,
    },
    className: {
      label: "Class Name",
      type: "text",
    },
  },
  defaultProps: {
    bannerId: "",
    bannerAltText: "Tamda Media Banner",
    bannerLink: "",
    bannerTarget: "_blank",
    bannerClickUrl: "",
    bannerImpressionHtml: "",
    bannerVendorScriptSrc: "",
    bannerVendorNoscriptHtml: "",
    showBanner: true,
    contactPhone: "+420 771 268 888",
    currencyRateText: "",
    showHeaderDetail: true,
    menuName: "Tamda Media Header - VI",
    showHeaderList: true,
    facebookLink: "https://facebook.com",
    youtubeLink: "https://youtube.com",
    facebookIcon: "",
    youtubeIcon: "",
    className: "",
  },
  ...RenderConfig,
}
